import { useState } from "react";
import {customerShopRegistration} from  "../services/shopUserService";


const useShopeRegistration = () => {
    const [status, setStatus] = useState("idle"); // idle | loading | done | error
    const [error, setError] = useState("");
    const [data, setData] = useState([]);

    const sentCustomerShopCreate = async (req) => {
        setStatus("loading");
        setError("");
    
        try {
          const response = await customerShopRegistration(req);
    
          if (response?.status !== "Error") {
            // setData(response.data ?? response); // depending on API shape
            // setStatus("done");
            //success();
            return response;
          } else {
            setStatus("error"); 
            setError(response?.message || "Something went wrong");
          }
        } catch (err) {
          setStatus("error");
          setError(err?.message || "Something went wrong");
        }
      };

      const resetStatus = () => {
    setStatus("idle");
    setError("");
  };

  return {
    sentCustomerShopCreate,
    data,
    status,
    error,
    resetStatus,
  };

}

export default useShopeRegistration;